import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import constant from "../../constant";
import OnboardPatientForm from "../ui/onboardPatientForm";

const AddOnboardPatient = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [doctors, setDoctors] = useState([]);
  const [devices, setDevices] = useState([]);
  const [hospitalId, setHospitalId] = useState(localStorage.getItem('hospitalId'));

  useEffect(() => {
    const fetchDoctorsAndDevices = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No authentication token found');
        return;
      }

      try {
        const doctorsResponse = await fetch(`${constant.REACT_APP_API_URL}/hospital/${hospitalId}/doctor/`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const doctorsResult = await doctorsResponse.json();
        if (doctorsResponse.ok) {
          setDoctors(doctorsResult || []);
        } else {
          setError(doctorsResult.msg || 'Failed to fetch doctors');
        }

        const devicesResponse = await fetch(`${constant.REACT_APP_API_URL}/hospital/${hospitalId}/devices?type=unassigned`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const devicesResult = await devicesResponse.json();
        if (devicesResponse.ok) {
          setDevices(devicesResult || []);
        } else {
          setError(devicesResult.msg || 'Failed to fetch devices');
        }
      } catch (error) {
        setError(error.message || 'Error fetching data');
      }
    };

    fetchDoctorsAndDevices();
  }, [hospitalId]);

  const handleCancel = () => {
    navigate(`/admin/patients/${hospitalId}`);
  };

  const handleClearError = () => {
    setError(null);
  };

  const handleSubmit = async (patientData) => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No authentication token found');
      }
console.log(patientData);
      const apiData = {
        patient_hospital_id: patientData.patient_hospital_id,
        bed_number: patientData.bed_number,
        ward_name: patientData.ward_name,
        name: patientData.name,
        // date_of_birth: patientData.date_of_birth,
        age: patientData.age,
        gender: patientData.gender.toLowerCase(),
        admitted_on: patientData.admitted_on,
        device_id: patientData.device_id,
        doctor_id: patientData.doctor_id,
        // caretaker_name: patientData.caretaker_name,
        // caretaker_email: patientData.caretaker_email,
        // caretaker_mobile: patientData.caretaker_mobile,
      };

      const response = await fetch(`${constant.REACT_APP_API_URL}/hospital/${hospitalId}/patient/`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(apiData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.msg || `Failed to add patient. Status: ${response.status}`);
      }

      setSuccessMessage('Patient added successfully!');
      setTimeout(() => navigate(`/admin/patients/${hospitalId}`), 1500); // Navigate after showing success
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6 pt-20 md:pt-4">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <div className="flex items-center space-x-4">
            <button onClick={handleCancel} className="text-gray-500 hover:text-gray-700 transition-colors">
              <ArrowLeft className="h-6 w-6" />
            </button>
            <h2 className="text-2xl font-bold text-gray-800">Add Patient</h2>
          </div>
        </div>

        {successMessage && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4" role="alert">
            <strong className="font-bold">Success!</strong>
            <span className="block sm:inline ml-2">{successMessage}</span>
          </div>
        )}

        <OnboardPatientForm
          doctors={doctors}
          devices={devices}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isEditMode={false}
          error={error}
          onClearError={handleClearError}
        />
      </div>
    </div>
  );
};

export default AddOnboardPatient;